import { Button } from '@/components/ui/button.tsx'
import { useMutateLabel } from '@/requests/mutations/useMutateLabel.ts'

type Props = {
  label: Label
  onClose: () => void
}

export const DeleteLabelModal = ({ label, onClose }: Props) => {
  const { remove } = useMutateLabel()

  return (
    <div className="bg-stateLayer-onLight-enabled flex px-1 py-1 items-center gap-1">
      <div className="flex-1 font-EN-KR-body2-regular text-contents-primary">
        Are you sure you want to delete <span className="text-labelType-label">"{label.name}"</span>
      </div>
      <div className="flex gap-[1px]">
        <Button
          type="button"
          variant="outline"
          className="h-5 px-1 py-2 w-[49px] font-EN-KR-caption-regular rounded-xs"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="alert"
          className="h-5 px-1 py-2 w-[49px] font-EN-KR-caption-regular rounded-xs"
          onClick={() => remove(label).then(onClose)}
        >
          Delete
        </Button>
      </div>
    </div>
  )
}
